















































import Component from 'vue-class-component'
import TextArea from '@/components/inputs/TextArea.vue'
import Vue from 'vue'
import Select from '@/components/Select.vue'
import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'

@Component({
  props: {
    newTask: {
      required: true
    }
  },
  components: { Select, TextArea }
})
export default class CollectionActionEscalate extends CollectionSharedFunctions {
  mounted () {
    this.changeEscalateUser(this.facilityCollectionSettings.escalatedIssuesUser)
  }

  changeEscalateUser (value: number) {
    this.$props.assignedUser = value
    this.$forceUpdate()
  }

  validateTaskNote () {
    return !!this.$props.newTask.note && !!this.$props.assignedUser
  }

  setNewTaskField (propName: string, item: any) {
    this.$set(this.$props.newTask, propName, item)
    this.$forceUpdate()
  }

  async changeResidentEscalation () {
    if (!this.validateTaskNote()) {
      return
    }

    this.$emit('submit', {
      functionName: 'changeResidentEscalation',
      successMessage: `Resident ${this.selectedTask.isEscalated ? 'Deescalated' : 'Escalated'}`,
      payloadData: {
        note: this.$props.newTask.note as string,
        isEscalated: !this.selectedTask.isEscalated,
        assignedUser: this.$props.assignedUser
      }
    })
  }
}
